import { useMutation, useQuery } from '@tanstack/react-query';
import apiClient from './apiClient';

export const differimentDetailKeys = {
  detail: (uuid) => ['differiments', 'detail', uuid],
};

export const useMarkDifferimentPayment = (options = {}) =>
  useMutation({
    mutationFn: async (uuid) => {
      await apiClient.patch(`differiments/payments/${uuid}/mark-paid`);
    },
    ...options,
  });

export const useDeleteDifferimentPayment = (options = {}) =>
  useMutation({
    mutationFn: async (uuid) => {
      await apiClient.delete(`differiments/payments/${uuid}`);
    },
    ...options,
  });

export const useGenerateDifferimentPaymentQr = (options = {}) =>
  useMutation({
    mutationFn: async (uuid) => {
      const response = await apiClient.post(`differiments/payments/${uuid}/qr`);
      return response.data;
    },
    ...options,
  });

export const useCreateManualDifferimentPayment = (options = {}) =>
  useMutation({
    mutationFn: async ({ contractUuid, amount, installmentsToPay, cuotaPura }) => {
      const response = await apiClient.post(`differiments/${contractUuid}/pay/manual`, {
        amount,
        installments_to_pay: installmentsToPay,
        cuota_pura: cuotaPura,
      });
      return response.data;
    },
    ...options,
  });

export const useIssueDifferimentInvoiceBatch = (options = {}) =>
  useMutation({
    mutationFn: async (payload) => {
      const response = await apiClient.post('differiment-invoices/batch', payload);
      return response.data;
    },
    ...options,
  });

export const useDifferimentPaymentPrint = (options = {}) =>
  useMutation({
    mutationFn: async (uuidPayment) => {
      const response = await apiClient.get(`differiments/payments/${uuidPayment}/print`);
      const { pdf_base64, download_name } = response.data;

      if (pdf_base64) {
        const byteCharacters = atob(pdf_base64);
        const byteNumbers = new Array(byteCharacters.length);
        for (let i = 0; i < byteCharacters.length; i += 1) {
          byteNumbers[i] = byteCharacters.charCodeAt(i);
        }
        const byteArray = new Uint8Array(byteNumbers);
        const blob = new Blob([byteArray], { type: 'application/pdf' });

        const url = window.URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', download_name || 'pago_diferimiento.pdf');
        document.body.appendChild(link);
        link.click();
        link.parentNode.removeChild(link);
      }

      return response.data;
    },
    ...options,
  });

export const useDifferimentDetail = (uuid_contract, options = {}) =>
  useQuery({
    queryKey: differimentDetailKeys.detail(uuid_contract),
    queryFn: async () => {
      const response = await apiClient.get(`differiments/${uuid_contract}`);
      return response.data;
    },
    enabled: Boolean(uuid_contract),
    staleTime: 5 * 60 * 1000,
    gcTime: 10 * 60 * 1000,
    ...options,
  });
